//#warning-js [data-consistency] should better separate between src/common/types and /src/repository/models

export interface SuperviseCallDto {
	scenarioId: string;
	supervisingAgentId: string;
    monitoringType: MonitorTypes
}

export class EjectParticipantRequest {
    scenarioId?: string;
    participantId?: string;
    tenantId?: string;
}

export enum MonitorTypes {
    None = 0,
    Silent = 1,
    Whisper = 2,
    BargeIn = 3,
    Ringing = 4,
    BySomeoneElse = 100
}

export enum MonitoringStartResponse {
	Success = 0,
	CallNotFound = 1,
	CallNotSupportingMonitoring = 2,
	AgentAlreadyMonitoringSameCall = 3,
	AgentAlreadyMonitoringADifferentCall = 4,
	CallMonitoredByADifferentAgent = 5,
    InternalError = 10
}
